import React, { useState, useEffect } from 'react';

import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Button, TextField } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { forgot_password } from '../../../../api/API';


const useStyles = makeStyles(theme => ({
    root: {},

    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }

    },

    submitButton: {
        marginTop: theme.spacing(2),
        width: '100%',

        "&:hover": {
            background: "#CECAC1"
        },
    }

}));

export default function Form(props) {
    const { className, ...rest } = props;
    const [hasSubmitted, setHasSubmitted] = useState(false);
    const classes = useStyles();
    const history = useHistory();
    // const router = useRouter();
    // const dispatch = useDispatch();

    const [email, setEmail] = useState("");



    const handleSubmit = async event => {

        event.preventDefault();
        if (email == "") {
            alert("Please fill in email");
            return;
        }

         forgot_password(email);
        setHasSubmitted(true);
        // });
    };


    return (
        <form
            {...rest}
            className={clsx(classes.root, className)}
            onSubmit={handleSubmit}
        >
            <div className={classes.fields}>

                {!hasSubmitted ? (
                    <TextField
                        fullWidth
                        label="Email"
                        name="username"
                        required={true}
                        onChange={(e) => { setEmail(e.target.value) }}
                        value={email}
                        variant="outlined"
                    />
                ) :
                    <h3 >Please check your email for the reset instructions</h3>
                }


            </div>
            {
                !hasSubmitted && (<Button
                    className={classes.submitButton}
                    color="secondary"
                    size="large"
                    type="submit"
                    variant="contained"
                >
                    CONFIRM
                </Button>)
            }

        </form>
    );
}
